<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Alarms</h2>
      </div>

      <div>
        <Warnings2 />
      </div>
    </div>
  </div>
</template>

<script>
import Warnings2 from "./Warnings2";

export default {
  name: "Index2",
  components: {
    Warnings2
  },
  computed: {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/warnings/Index2.vue